import { useQuery } from "@tanstack/react-query";
import fetcher from "./fetcher";

function useCustomQuery(key, url, token) {
  return useQuery(key, () => fetcher(url, token));
}
export default useCustomQuery;
